var Broadcaster = (function ($, document) {
    "use strict";
    
    function Broadcaster() {}
    
    Broadcaster.prototype = {
        /**
        * Emit an event with an object to a dom element
        * 
        * @param {String} event    The event name
        * @param {Object} args     Any args to be sent with the event
        * @param {String}          Optional jQuery element selector (could be "document")
        *
        * @returns {void}          Trigger event to given element
        */
        send: function(event, args, to) {
            if (!to) {
                to = document;
            }

            event = event.replace('.', '_');
            
            $(to).trigger(event, args);
        },

        on: function(event, callback) {
            event = event.replace('.', '_');

            $(document)
                .off(event)
                .on(event, function(e, args) {
                    if (typeof callback == 'function') {
                        callback(e, args);
                    }
                });
        }
    };
    
    return Broadcaster;
})(jQuery, document);

var App = App || {};
App.Broadcaster = new Broadcaster();
